import { render, staticRenderFns } from "./spareParts.vue?vue&type=template&id=1cfa4cfa&scoped=true&"
import script from "./spareParts.vue?vue&type=script&lang=js&"
export * from "./spareParts.vue?vue&type=script&lang=js&"
import style0 from "./spareParts.vue?vue&type=style&index=0&id=1cfa4cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfa4cfa",
  null
  
)

export default component.exports